import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { useState, useEffect } from "react";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function MobileCallButton() {
  return (
    <a
      href="tel:18884589181"
      className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[9999] flex items-center gap-2 bg-[#D4A853] text-white px-6 py-3 rounded-full shadow-lg hover:bg-[#B8923D] transition-all cursor-pointer whitespace-nowrap lg:hidden animate-bounce-subtle"
      style={{ animationDuration: '2s' }}
    >
      <span className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center">
        <i className="ri-phone-fill text-lg"></i>
      </span>
      <span className="text-sm font-bold tracking-wide">Call Now</span>
    </a>
  );
}

function WhatsAppButton() {
  const [isOpen, setIsOpen] = useState(false);
  const phoneNumber = "18884589181";
  const defaultMessage = "Hi! I'm interested in your security services. Can you help me?";

  return (
    <div className="fixed bottom-6 left-6 z-[9998] hidden lg:block">
      {isOpen && (
        <div className="absolute bottom-16 left-0 w-80 bg-white rounded-2xl shadow-2xl border border-gray-100 overflow-hidden animate-fade-in-up">
          <div className="bg-[#25D366] px-5 py-4 flex items-center gap-3">
            <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
              <i className="ri-whatsapp-fill text-white text-xl"></i>
            </div>
            <div>
              <p className="text-white font-semibold text-sm">Alarm Guard Security</p>
              <p className="text-white/80 text-xs">Typically replies within minutes</p>
            </div>
            <button
              onClick={() => setIsOpen(false)}
              className="ml-auto w-6 h-6 flex items-center justify-center text-white/80 hover:text-white cursor-pointer"
            >
              <i className="ri-close-line text-lg"></i>
            </button>
          </div>
          <div className="p-4 bg-[#ECE5DD]">
            <div className="bg-white rounded-lg p-3 shadow-sm max-w-[85%]">
              <p className="text-gray-800 text-sm leading-relaxed">
                👋 Hello! Welcome to Alarm Guard Security. How can we help you today?
              </p>
              <p className="text-[11px] text-gray-400 mt-1 text-right">Just now</p>
            </div>
          </div>
          <div className="p-3 bg-white border-t border-gray-100">
            <a
              href={`https://wa.me/${phoneNumber}?text=${encodeURIComponent(defaultMessage)}`}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="flex items-center justify-center gap-2 w-full bg-[#25D366] hover:bg-[#1DA851] text-white py-3 rounded-xl font-semibold text-sm transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-fill text-lg"></i>
              Start Chat on WhatsApp
            </a>
          </div>
        </div>
      )}
    </div>
  );
}

function StickyQuoteButton() {
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Hide on the free-quote page itself
  const isQuotePage = location.pathname === '/free-quote';
  if (isQuotePage) return null;

  const handleClick = () => {
    window.REACT_APP_NAVIGATE?.('/free-quote');
  };

  return (
    <button
      onClick={handleClick}
      aria-label="Get a Free Quote"
      className={`fixed right-5 bottom-24 z-[9997] flex items-center gap-2 bg-[#D4A853] text-white pl-4 pr-5 py-3 rounded-full shadow-2xl hover:bg-[#B8923D] transition-all cursor-pointer whitespace-nowrap font-bold text-sm border-2 border-white/30 ${
        visible ? 'translate-x-0 opacity-100 scale-100' : 'translate-x-[140%] opacity-0 scale-95'
      }`}
      style={{ transition: 'transform 0.4s cubic-bezier(0.34,1.56,0.64,1), opacity 0.3s ease, background-color 0.2s ease' }}
    >
      <span className="w-7 h-7 bg-white/25 rounded-full flex items-center justify-center shrink-0">
        <i className="ri-file-text-line text-base"></i>
      </span>
      Get Free Quote
      <span className="w-5 h-5 flex items-center justify-center shrink-0">
        <i className="ri-arrow-right-line text-sm"></i>
      </span>
    </button>
  );
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <ScrollToTop />
        <AppRoutes />
        <MobileCallButton />
        <StickyQuoteButton />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
